import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Button } from 'primereact/button';
// import { useSelector } from 'react-redux';
import React from 'react';
import { CourseAssignmentDTO } from '../courseAssignment/types';
// import FaceIcon from '../../../assets/facePink.png';
// import { selectCurrentUser } from '../../../pages/login/authSlice';
// import { CircularTrainingAttainment } from '../../../components/customProgressBar/CircularTrainingAttainment';

interface courseTLAssignmentProps {
    courseAssignments: any;
}

export const CourseTLAssignment = ({ courseAssignments }: courseTLAssignmentProps) => {
    // const loggedEmpUserName = useSelector(selectCurrentUser);
    // const [trainingAttainment, setTrainingAttainment] = useState<any | null>(null);
    const linkTemplate = (rowData: CourseAssignmentDTO) => {
        return rowData.linkUrl ? (
            <a href={rowData.linkUrl} target="_blank" rel="noopener noreferrer">
                Open Link
            </a>
        ) : null;
    };

    const statusStyles: Record<number, { color: string }> = {
        1: { color: '#FDD444' },
        2: { color: '#3299FF' },
        3: { color: '#82DD55' },
        4: { color: '#E23636' },
    };

    const statusBodyTemplate = (rowData: any) => {
        const status = statusStyles[rowData.coachingToDoStatusId];
        if (!status) return null;
        const statusLabelOverrides: Record<string, string> = {
            1: 'Not Started', // To Do
            3: 'Completed', // Done
            4: 'Help', // Needs Help
        };
        const label = statusLabelOverrides[rowData.coachingToDoStatusId] || rowData.coachingToDoStatus;

        return (
            <div style={{ position: 'relative', height: '30px' }}>
                <Button
                    iconPos="left"
                    style={{
                        backgroundColor: status.color,
                        height: '29px',
                        padding: '4px 8px',
                        borderRadius: '8px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '12px',
                        width: '100px',
                        cursor: 'default',
                        border: 'none',
                    }}
                >
                    <span>{label}</span>
                </Button>
            </div>
        );
    };

    // useEffect(() => {
    //     if (courseAssignments?.length > 0) {
    //         const countByStatusId = courseAssignments?.reduce((acc: any, item: any) => {
    //             const statusId = item.coachingToDoStatusId;
    //             if (typeof statusId === 'number') {
    //                 return {
    //                     ...acc,
    //                     [statusId]: (acc[statusId] || 0) + 1,
    //                 };
    //             }
    //             return acc;
    //         }, {});
    //         setTrainingAttainment(countByStatusId);
    //     }
    // }, [courseAssignments]);

    return (
        <div>
            {/* <div
                style={{
                    position: 'relative',
                    zIndex: 10,
                    display: 'flex',
                    justifyContent: 'space-between',
                    height: '100%',
                    padding: '30px 24px 24px',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '48px', width: '1102px' }}>
                    <img style={{ width: '150px', height: '150px' }} alt="Avatar" src={FaceIcon} />

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <h2
                            style={{
                                fontFamily: 'Urbanist',
                                fontWeight: 'bold',
                                color: '#3f5765',
                                fontSize: '24px',
                            }}
                        >
                            Where Do I stand?
                        </h2>

                        <p style={{ fontFamily: 'Urbanist', fontSize: '24px' }}>
                            <span style={{ color: '#3f5765', fontWeight: '400' }}>
                                Hello {loggedEmpUserName}, your associates Need Help with their assigned
                                training, please review the status.
                            </span>
                        </p>
                    </div>
                </div>
                <div className="metric-target-container">
                    <div className="right">
                        {trainingAttainment && <CircularTrainingAttainment data={trainingAttainment} />}
                    </div>
                </div>
            </div> */}
            <div className="card">
                <DataTable
                    value={courseAssignments}
                    rows={10}
                    responsiveLayout="scroll"
                    emptyMessage="No records found."
                    paginator={courseAssignments?.data?.length > 5}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                >
                    <Column field="associate" header="Associate" sortable />
                    <Column field="metric" header="Metric" sortable />
                    <Column field="skill" header="Skill" sortable />
                    <Column field="behavior" header="Behavior" sortable />
                    <Column body={statusBodyTemplate} header="Status" sortable sortField='coachingToDoStatusId' />
                    <Column field="courseAssigned" header="Course Assigned" sortable />
                    <Column field="teamLead" header="Team Lead" sortable />
                    <Column header="Link" body={linkTemplate} />
                </DataTable>
            </div>
        </div>
    );
};
